<template>
  <div class="sorting-control">
    <span class="sorting-control__label ms-help">
      По:
    </span>
    <i-select
      v-model="sortBy"
      :size="size || 'small'"
      style="width:128px"
      :transfer="false"
    >
      <i-option
        v-for="item in values"
        :value="item.field"
        :key="item.field"
      >
        {{ item.name }}
      </i-option>
    </i-select>
    <i-button
      @click="changeSort"
      class="sorting-control-btn"
      :icon="sortMode === 'asc' ? 'md-trending-up' : 'md-trending-down'"
      shape="circle"
    />
  </div>
</template>

<script>
export default {
  props: ['type', 'values', 'size'],
  computed: {
    sortBy: {
      get () {
        return this.$store.state.filters[this.type].sortBy
      },
      set (value) {
        this.$store.commit('CHANGE_FILTER', {
          type: this.type,
          field: 'sortBy',
          value
        })
      }
    },
    sortMode () {
      return this.$store.state.filters[this.type].sortMode
    }
  },
  methods: {
    changeSort () {
      const value = this.sortMode === 'asc' ? 'desc' : 'asc'

      this.$store.commit('CHANGE_FILTER', {
        type: this.type,
        field: 'sortMode',
        value
      })
    }
  }
}
</script>

<style lang="less">
.sorting-control {
  display: flex;
  align-items: center;

  &__label {
    margin-right: 8px;
  }

  &-btn {
    margin-left: 8px;
  }
}
</style>
